.baseButton {
	border-radius: 6px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: fit-content;
	line-height: 16px !important;
	gap: 8px;
	text-decoration: none;
	width: fit-content;
	box-sizing: border-box;
	/* Sum of both sides */
	--border-inline-size: 2px;
}

.baseButton:focus-visible {
	outline: var(--focus-outline);
}

.md:not(.iconOnly) {
	padding: calc(12px - var(--border-inline-size)) calc(16px - var(--border-inline-size));
}

.md {
	padding: calc(16px - var(--border-inline-size));
}

.sm:not(.iconOnly) {
	padding: calc(8px - var(--border-inline-size)) calc(12px - var(--border-inline-size));
}

.sm {
	padding: calc(8px - var(--border-inline-size)) !important;
}

.baseButton[data-loading="true"] {
	cursor: progress !important;
}

.baseButton:disabled:not([data-loading="true"]),
.baseButton[data-visually-disabled="true"]:not([data-loading="true"]) {
	cursor: not-allowed;
}

.primary {
	background-color: var(--background-secondary);
	color: var(--content-secondary);
	border: var(--background-secondary) solid 1px;
}

.primary:disabled,
.primary[data-visually-disabled="true"] {
	background-color: var(--background-secondary-high);
	border: var(--background-secondary-high) solid 1px;
}

.primary:hover:not(:disabled):not([data-visually-disabled="true"]) {
	background-color: var(--background-secondary-high);
	border: var(--background-secondary-high) solid 1px;
}

.secondary {
	background-color: transparent;
	border: var(--border-primary) solid 1px;
	color: var(--content-primary);
}

.secondary:disabled,
.secondary[data-visually-disabled="true"] {
	background-color: var(--elevation-medium);
}

.secondary:hover:not(:disabled):not([data-visually-disabled="true"]) {
	background-color: var(--elevation-medium);
}

.tertiary {
	composes: body-2 from global;
	border-bottom: var(--background-secondary) solid 1.5px;
	color: var(--content-primary);
	border-radius: 0;
	padding-inline: 0 !important;
	height: calc(var(--body-2-line-heigth) + 4px);
}

.tertiary:hover {
	background-color: var(--elevation-medium);
}

.danger {
	color: var(--content-secondary);
	background-color: var(--background-danger-low);
	border: var(--background-danger-low) solid 1px;
}

.danger:disabled,
.danger[data-visually-disabled="true"] {
	background-color: var(--background-danger-high);
	border: var(--background-danger-high) solid 1px;
}

.danger:hover:not(:disabled):not([data-visually-disabled="true"]) {
	background-color: var(--background-danger-high);
	border: var(--background-danger-high) solid 1px;
}

.fullWidth {
	width: 100%;
	padding: 8px 16px;
}

.iconOnly {
	border: solid 1px transparent;
	background-color: transparent;
}

.loader {
	width: 12px;
	aspect-ratio: 1;
	border-radius: 50%;
	border: 1px solid currentColor;
	margin-top: -1px;
	animation:
		l20-1 1s infinite linear alternate,
		l20-2 2s infinite linear;
}

@keyframes l20-1 {
	0% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
	}

	12.5% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%);
	}

	25% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%);
	}

	50% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
	}

	62.5% {
		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
	}

	75% {
		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%);
	}

	100% {
		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%);
	}
}

@keyframes l20-2 {
	0% {
		transform: scaleY(1) rotate(0deg);
	}

	49.99% {
		transform: scaleY(1) rotate(135deg);
	}

	50% {
		transform: scaleY(-1) rotate(0deg);
	}

	100% {
		transform: scaleY(-1) rotate(-135deg);
	}
}
